export const en = {
  referralPage: {
    meta: {
      title: 'Referral Program — Earn $1,000 for every company you refer',
    },
    header: {
      eyebrow: 'Referral Program',
      subtitle:
        "Know a People team or VP of Employee Experience who'd love Purposely? Send them an intro. When they sign on, you get a $1,000 reward and they get 10% off their first year.",
      cta: 'Make a referral',
      ctaSecondary: 'See how it works',
      mini: 'No cap on referrals · Paid out after a 1-year contract signs',
    },
    rewards: {
      you: {
        tag: 'You get',
        amount: '$1,000',
        unit: 'USD',
        headline: 'Cash reward, no strings',
        desc: 'Paid out for every successful referral that signs a 1-year contract with Purposely.',
      },
      them: {
        tag: 'They get',
        amount: '10%',
        unit: 'off year 1',
        headline: 'A warm welcome to the platform',
        desc: 'Their team gets a discount on their first year of Purposely — plus white-glove onboarding from our team.',
      },
    },
    collage: {
      eyebrow: 'Our community',
      title: 'Real teams. Real impact. Real referrals.',
    },
    howItWorks: {
      eyebrow: 'How it works',
      titleHighlight: '$1,000 reward',
      subtitle: 'From intro email to payout — most referrals close in under 30 days.',
      options: {
        sendEmail: {
          title: 'Send an email',
          subtitle:
            "Use the form on this page (or your own inbox) to send a warm intro to anyone you think would love Purposely. CC eric@purposely.co and we'll take it from there.",
        },
        friendGetsMessage: {
          title: 'Your friend gets the message',
          subtitle:
            "We'll reach out, share a tailored walkthrough, and run the demo. You're hands-off from here — we keep you posted at each step.",
        },
        getRewarded: {
          title: 'Get rewarded',
          subtitle:
            "When the referred team signs a 1-year contract, we'll pay out your $1,000 reward within 14 business days.",
        },
      },
    },
    form: {
      eyebrow: 'Make a referral',
      title: 'Send an intro in two minutes.',
      subtitle:
        "Tell us who to reach out to. We'll take it from there and keep you in the loop. Your details only get used to track and credit your referral.",
      checklist: [
        "We'll CC you when we reach out",
        'Unlimited referrals, no cap',
        'Paid out within 14 days of contract signing',
      ],
      helperHeading: 'Already sent the email?',
      helperBody:
        "Just make sure eric@purposely.co is CC'd and we'll log the referral automatically.",
      frameLabel: 'Referral form',
    },
    template: {
      eyebrow: 'Email template',
      title: 'Copy & paste our template',
      titleHighlight: 'to make it easier.',
      subtitle:
        "Don't know what to say? Use this as a starting point. Tweak it to sound like you, drop in a personal note, and hit send.",
      greeting: "Hi [Friend's Name],",
      paragraph1:
        "Hope you're doing well! I wanted to reach out in case your company is exploring ways to make employee engagement more impactful through volunteering. Would you forward this message to your VP People or VP Employee Experience to learn about Purposely, and consider it for your org?",
      paragraph2:
        "Here's a quick blurb you can pass along to anyone who might be interested:",
      paragraph3:
        'Purposely helps companies run structured, high-impact employee volunteer programs without the usual coordination headaches. It\'s built for teams to drive real engagement through group volunteering, while tracking participation and impact along the way. Companies like Clio, Boston Dynamics, and GreenShield are already using it to power their programs.',
      links: {
        title: 'A few helpful links:',
        overview: 'Purposely Overview',
        caseStudy: 'Clio Case Study',
      },
      ccReminder: "Don't forget to CC eric@purposely.co",
      copyButton: 'Copy template',
      alertSuccess: 'Template copied to clipboard!',
      alertError: 'Failed to copy text. Please try again.',
    },
    termsAndConditions: {
      title: 'Terms and conditions',
      subtitle:
        'The simple version: send genuine intros, the lead has to close a 1-year deal, and we pay you. The full version is below.',
      items: [
        {
          title: 'Rewards are issued on a signed contract',
          body: 'The $1,000 reward is paid out only when a referred organization signs a one-year or longer contract with Purposely.',
        },
        {
          title: 'Qualifying referrals',
          body: "Referrals must be initiated via email introduction (with eric@purposely.co CC'd) or through the form on this page. Purposely may update or end the referral program at any time without prior notice.",
        },
        {
          title: 'Disputes & eligibility',
          body: 'In the event of a dispute, Purposely will determine final eligibility and reward decisions. Employees of Purposely and current customers are not eligible to receive referral rewards for their own organization.',
        },
        {
          title: 'Payout method & timing',
          body: 'Rewards are paid by wire, ACH, or gift card (your choice) within 14 business days of the referred contract being signed. Local taxes are your responsibility.',
        },
      ],
    },
  },
}
